<template>
  <div class="nkn-footer">
    <div class="nkn-footer-body">
      <div class="body-container">
        <nkn-footer-link></nkn-footer-link>
        <nkn-footer-subscribe></nkn-footer-subscribe>
      </div>
    </div>
    <div class="nkn-footer-bottom">
      <div class="container">
        <div class="nkn-copyright">{{$t("footer.copyright")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import nknFooterLink from "@/components/footer/nknFooterLink";
import nknFooterSubscribe from "@/components/footer/nknFooterSubscribe";
import { mapGetters } from "vuex";
export default {
  components: {
    nknFooterLink,
    nknFooterSubscribe
  },
  computed: {
    ...mapGetters({
      lang: "getLang"
    })
  }
};
</script>

<style lang="scss" scoped>
.nkn-footer {
  .container {
    padding: 0;
  }
  .col-md-8 {
    width: 700px;
    float: left;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .subscribe.col-md-4 {
    width: 420px;
    float: right;
    @media screen and (max-width: 768px) {
      width: 240px;
    }
  }

  @media screen and (max-width: 768px) {
    .footer-link {
      width: 100%;
    }
    .subscribe {
      width: 100% !important;
    }
  }
  &-body {
    background-color: #27387b;
    position: relative;
    @media screen and (max-width: 768px) {
      .container {
        padding: 0;
      }
    }
    //@include nkn-bg-img($url: $footer-body-bg);

    .body-container {
      display: flex;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: 768px) {
        padding-left: 20px;
        padding-right: 20px;
        flex-direction: column;
      }
    }
  }

  &-bottom {
    line-height: 36px;
    background: #1a2860;

    .container {
      background: inherit;
    }

    .nkn-copyright {
      @include nkn-font-set(0.7rem, #fff, 300);
      background-color: #1a2860;
      text-align: center;
      letter-spacing: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/nknFooter.vue